import { render, staticRenderFns } from "./ClientPersonalInfoHandler.vue?vue&type=template&id=d264ed3e&scoped=true&"
import script from "./ClientPersonalInfoHandler.vue?vue&type=script&lang=js&"
export * from "./ClientPersonalInfoHandler.vue?vue&type=script&lang=js&"
import style0 from "./ClientPersonalInfoHandler.vue?vue&type=style&index=0&id=d264ed3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d264ed3e",
  null
  
)

export default component.exports